// extracted by mini-css-extract-plugin
export default {"main":"feed-page_main__i74W-"};